import React from "react";

import Avatar from "components/common/Avatar";

import { getCountryFlag } from "components/Screens/CommonUtils";

import {
  ArrowDropDown as ArrowDropDownIcon,
  HealingOutlined as HealingOutlinedIcon,
  ChildCareOutlined as ChildCareOutlinedIcon,
  FlightTakeoff as FlightTakeoffIcon,
  MosqueOutlined as MosqueOutlinedIcon,
  HeartBrokenOutlined as HeartBrokenOutlinedIcon,
  MoneyOffCsredOutlined as MoneyOffCsredOutlinedIcon,
  SwapHorizOutlined as SwapHorizOutlinedIcon,
  FamilyRestroomOutlined as FamilyRestroomOutlinedIcon,
  FemaleOutlined as FemaleOutlinedIcon,
  FavoriteBorderOutlined as FavoriteBorderOutlinedIcon,
} from "@mui/icons-material";

export const mapApiValueToFormValue = (apiValue, fieldType, apiKey) => {
  if (apiValue === null || apiValue === undefined) return null;

  if (apiKey === "monthlyAccrualApplicable") {
    return apiValue === true ? "yes" : "no";
  }

  if (apiKey === "limitAccrualToFirstYear") {
    return apiValue === true ? "no" : "yes";
  }

  if (apiKey === "carryForwardApplies") {
    return apiValue === true ? "yes" : "no";
  }

  if (fieldType === "radio") {
    return apiValue === true ? "yes" : "no";
  }

  if (typeof apiValue === "number") {
    return apiValue.toString();
  }

  return apiValue;
};

export const POLICY_ICONS = {
  Annual: <FlightTakeoffIcon fontSize="small" />,
  Sick: <HealingOutlinedIcon fontSize="small" />,
  Maternity: <ChildCareOutlinedIcon fontSize="small" />,
  Paternity: <ChildCareOutlinedIcon fontSize="small" />,
  Bereavement: <HeartBrokenOutlinedIcon fontSize="small" />,
  Pilgrimage: <MosqueOutlinedIcon fontSize="small" />,
  Unpaid: <MoneyOffCsredOutlinedIcon fontSize="small" />,
  Swapped: <SwapHorizOutlinedIcon fontSize="small" />,
  Adoption: <FamilyRestroomOutlinedIcon fontSize="small" />,
  "Women's Health": <FemaleOutlinedIcon fontSize="small" />,
  Wedding: <FavoriteBorderOutlinedIcon fontSize="small" />,
};

export const COUNTRY_DETAIL_TABLE_COLUMNS = [
  {
    id: "type",
    label: "Policy",
    minWidth: 170,
    render: (value) => (
      <div className="policy-cell">
        <span className="policy-icon">{POLICY_ICONS[value]}</span>
        <span className="para-body-m-regular">{value}</span>
      </div>
    ),
  },
  {
    id: "entitledDays",
    label: "Entitled days per year",
    minWidth: 180,
  },
  {
    id: "createdOn",
    label: "Created on",
    minWidth: 150,
  },
  {
    id: "lastUpdatedOn",
    label: "Last updated on",
    minWidth: 150,
  },
  {
    id: "createdBy",
    label: "Created by",
    minWidth: 150,
    render: (value = "Admin") => (
      <div className="created-by-cell">
        <Avatar size="md" variant="circular" alt={value} className="created-by-avatar">
          {value?.charAt(0)?.toUpperCase() || "A"}
        </Avatar>
        <span className="para-body-m-regular">{value}</span>
      </div>
    ),
  },
];

export function FlagIcon({ country }) {
  return getCountryFlag(country, 24, 24);
}

export function ArrowIcon() {
  return <ArrowDropDownIcon fontSize="small" className="color-icon-secondary" />;
}

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatLeaveQuota = (quota, type) => {
  if (quota === -1) return "Unlimited";
  if (quota === 0) return "As needed";
  return `${quota} ${type === "Annual" || type === "Sick" ? "working" : "calendar"} days`;
};

export const getEmployeesCount = (countriesData, country) => {
  const countryData = countriesData.find((item) => item.country === country);
  return countryData?.employeeCount || 0;
};

export const getPoliciesCount = (countriesData, country) => {
  const countryData = countriesData.find((item) => item.country === country);
  return countryData?.policyCount || 0;
};
